import type { ReactNode } from "react";
import {
  IconForkAndKnifePurple,
  IconPrecisionPurple,
  IconRxDietLogoPurple,
  IconShoppingCartPurple
} from "src/constants/icons";
import Translate from "src/ui/components/Translate/Translate";

export interface RxDietCardData {
  sectionTitle?: string | ReactNode;
  pillText?: string | ReactNode;
  pillImg?: string | ReactNode;
  title?: string | ReactNode;
  subtitle?: string | ReactNode;
  listItems?: {
    icon: string | ReactNode;
    text: string | ReactNode;
  }[];
  sliderImgs?: {
    src: string;
  }[];
  buttonText: string | ReactNode;
}

export interface RxDietData {
  card: RxDietCardData;
}

export interface RxDietDescriptionListItem {
  id: string;
  title: string | ReactNode;
  subtitles?: (string | ReactNode)[];
  optional?: boolean;
}

export const rxDietDescriptionListItems: (() => RxDietDescriptionListItem)[] = [
  () => ({
    id: "set-preferences",
    title: (
      <Translate msg="rxDiet.descriptionDialog.content.listItem_setPreferences" />
    ),
    subtitles: [
      <Translate
        key="household"
        msg="rxDiet.descriptionDialog.content.listItem_individualHouseholdProfile"
      />,
      <Translate
        key="lifestyle"
        msg="rxDiet.descriptionDialog.content.listItem_lifestyle"
      />
    ]
  }),
  () => ({
    id: "select-meal-plan",
    title: (
      <Translate msg="rxDiet.descriptionDialog.content.listItem_selectWeeklyMealPlan" />
    ),
    subtitles: [
      <Translate
        key="unlimitedMealGeneration"
        msg="rxDiet.descriptionDialog.content.listItem_unlimitedMealGeneration"
      />,
      <Translate
        key="included"
        msg="rxDiet.descriptionDialog.content.listItem_included"
      />
    ]
  }),
  () => ({
    id: "order-groceries",
    title: (
      <Translate msg="rxDiet.descriptionDialog.content.listItem_orderGroceries" />
    ),
    optional: true
  }),
  () => ({
    id: "cook-meals",
    title: (
      <Translate msg="rxDiet.descriptionDialog.content.listItem_cookMeals" />
    ),
    subtitles: [
      <Translate
        key="recipe"
        msg="rxDiet.descriptionDialog.content.listItem_recipeInstructions"
      />,
      <Translate
        key="nutritional"
        msg="rxDiet.descriptionDialog.content.listItem_nutritionalGuidance"
      />,
      <Translate
        key="rating"
        msg="rxDiet.descriptionDialog.content.listItem_rating"
      />
    ]
  })
];

export const getDefaultRxDietData = (): RxDietData => ({
  card: {
    pillText: <Translate msg="poweredBy" />,
    pillImg: <IconRxDietLogoPurple />,
    title: <Translate msg="rxDiet.card.title" />,
    subtitle: <Translate msg="rxDiet.card.subtitle" />,
    listItems: [
      {
        icon: <IconPrecisionPurple />,
        text: <Translate msg="rxDiet.card.listItem_nutrition" />
      },
      {
        icon: <IconForkAndKnifePurple />,
        text: <Translate msg="rxDiet.card.listItem_preferences" />
      },
      {
        icon: <IconShoppingCartPurple />,
        text: <Translate msg="rxDiet.card.listItem_delivery" />
      }
    ],
    sliderImgs: [
      {
        src: "https://cdn.sanity.io/images/g38rxyoc/production/2809224f21d8f29d3d4d5bb76f881c425397cdf2-200x200.jpg"
      },
      {
        src: "https://cdn.sanity.io/images/g38rxyoc/production/72cfb44d1a11287e995757204af9d94c666137ed-200x200.jpg"
      },
      {
        src: "https://cdn.sanity.io/images/g38rxyoc/production/9eef9ff2b477ebb014fad6cfa08399dcd4bba32a-204x204.jpg"
      },
      {
        src: "https://cdn.sanity.io/images/g38rxyoc/production/8cc09ce497866932b262461b846517e0d36a9a53-200x200.jpg"
      },
      {
        src: "https://cdn.sanity.io/images/g38rxyoc/production/fabbae4da087a6159c99fdc8379395ea5be4ec8a-200x200.jpg"
      },
      {
        src: "https://cdn.sanity.io/images/g38rxyoc/production/a26e43461b4b2a8c09728a9f64350afe1ad94e85-200x200.jpg"
      },
      {
        src: "https://cdn.sanity.io/images/g38rxyoc/production/148736822ae36d094919d714e60547cf772e8748-200x200.jpg"
      },
      {
        src: "https://cdn.sanity.io/images/g38rxyoc/production/3e4f9394d8d339a5591916b9fdec21b5a832ab53-200x200.jpg"
      }
    ],
    buttonText: <Translate msg="rxDiet.button.createFirstMealPlan" />
  }
});
